import styled from 'styled-components';
import { Container as TogglerContainer } from 'components/Toggler/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  titleScientific: {
    color: '#7833FF',
  },
}));

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;

  & ${TogglerContainer} {
    margin-bottom: 25px;
  }
`;
